import { render, staticRenderFns } from "./LivingOptionProperties.vue?vue&type=template&id=496d6bb6&scoped=true"
import script from "./LivingOptionProperties.vue?vue&type=script&lang=js"
export * from "./LivingOptionProperties.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionProperties.vue?vue&type=style&index=0&id=496d6bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d6bb6",
  null
  
)

export default component.exports